<ejs-toast (created)="onCreate()"
           (close)="toastService.remove(toast)"
           (click)="closeToast($event)"
           [showCloseButton]="true"
           [position]="position"
           [style]="'margin-top: ' + (100 * index - 1) + 'px'">
  <ng-template #title>
    <h5 class="d-flex align-items-center">
      <span class="e-icons icon-warning" *ngIf="toast.type === 'error' || toast.type === 'warning'"></span>
      <span class="e-icons icon-checkmark--outline" *ngIf="toast.type === 'success'"></span>
      <strong class="mx-1">{{ toast.header | translate }}</strong>
    </h5>
  </ng-template>
  <ng-template #content>
    <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    </ng-template>

    <ng-template #text>
      <div innerHTML="{{ toast.textOrTpl | translate:{placeholder: toast.placeholder} }}"></div>
      <div class="error-detail" *ngIf="toast.errorDetail">
        <div innerHTML="{{ 'i18n.errors.details' | translate }}"></div>
        <div innerHTML="{{ toast.errorDetail | translate }}"></div>
      </div>
    </ng-template>
  </ng-template>
</ejs-toast>
